import React from 'react';

import { IconProps } from './type';

export default function PhoneIcon({
  size = 20,
  className,
  ...props
}: React.ComponentProps<'svg'> & IconProps) {
  return (
    <svg
      width={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.7775 1.70454C5.79167 0.696204 7.46167 0.875371 8.31084 2.01037L9.3625 3.4137C10.0542 4.33704 9.9925 5.62704 9.17167 6.44287L8.97334 6.6412C8.95094 6.72448 8.94866 6.81188 8.96667 6.8962C9.01917 7.2362 9.30334 7.9562 10.4933 9.13954C11.6833 10.3229 12.4083 10.6062 12.7533 10.6595C12.8402 10.678 12.9302 10.6754 13.0158 10.652L13.3558 10.3137C14.0858 9.5887 15.2058 9.45287 16.1092 9.9437L17.7008 10.8104C19.065 11.5504 19.4092 13.4037 18.2925 14.5145L17.1083 15.6912C16.735 16.062 16.2333 16.3712 15.6217 16.4287C14.1133 16.5695 10.5992 16.3895 6.905 12.717C3.4575 9.2887 2.79584 6.2987 2.71167 4.82537C2.67 4.08037 3.02167 3.45037 3.47 3.00537L4.7775 1.70454ZM7.31084 2.75954C6.88834 2.19537 6.10167 2.15037 5.65834 2.5912L4.35 3.8912C4.075 4.16454 3.94334 4.4662 3.96 4.75454C4.02667 5.92537 4.56 8.62287 7.78667 11.8312C11.1717 15.1962 14.2975 15.297 15.5058 15.1837C15.7525 15.1612 15.9975 15.0329 16.2267 14.8054L17.41 13.6279C17.8917 13.1495 17.7858 12.2779 17.1042 11.9079L15.5125 11.042C15.0725 10.8037 14.5575 10.882 14.2375 11.2004L13.8583 11.5779L13.4167 11.1345C13.8583 11.5779 13.8575 11.5787 13.8567 11.5787L13.8558 11.5804L13.8533 11.5829L13.8475 11.5879L13.835 11.5995C13.7996 11.6319 13.7617 11.6614 13.7217 11.6879C13.655 11.732 13.5667 11.7812 13.4558 11.822C13.2308 11.9062 12.9325 11.9512 12.5642 11.8945C11.8417 11.7837 10.8842 11.2912 9.61167 10.0262C8.34 8.7612 7.84334 7.80954 7.73167 7.08787C7.67417 6.71954 7.72 6.4212 7.805 6.1962C7.85214 6.06976 7.91909 5.95162 8.00334 5.8462L8.03 5.81704L8.04167 5.80454L8.04667 5.79954L8.04917 5.79704L8.05084 5.79537L8.29084 5.55704C8.6475 5.2012 8.6975 4.61204 8.36167 4.16287L7.31084 2.75954Z"
        fill="currentColor"
      />
    </svg>
  );
}
